import type { FunctionComponent } from 'react';
import { SchoolFactsBrick } from './SchoolFactsBrick';
import { useSchoolPageBySlugTabContentQuery } from '../../../../graphql/useSchoolPageBySlugTabContentQuery';
import { mapWebLink } from '../../../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { isContentOverview } from '../../../../helpers/isContentOverview';

export const SchoolFactsBrickWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugTabContentQuery();
  const tabContent = data?.schoolPageBySlug?.tabContent;
  if (!tabContent || !isContentOverview(tabContent)) return null;

  const { schoolFacts } = tabContent;
  if (!schoolFacts) return null;

  return (
    <SchoolFactsBrick
      title={schoolFacts.title}
      subtitle={schoolFacts.subtitle}
      facts={schoolFacts.facts}
      naplanResultsLink={mapWebLink(schoolFacts.naplanResultsLink)}
    />
  );
};
